import { Toolbar, ToolbarProps, Button } from 'ra-ui-materialui'
import React from 'react'
import { SaveButton, useLoading, useSaveContext } from 'react-admin'
import { isProduction } from 'services/env'
import EventCreateConfirmationModal from 'ui-shared/Modal/EventCreateConfirmationModal'
import OpenModalButton from 'ui-shared/CustomButtons/OpenModalButton'
import { Save } from '@mui/icons-material'
import { useFormContext } from 'react-hook-form'

const EventCreateCustomToolbar: React.FC<ToolbarProps> = (props) => {
  const loading = useLoading()
  const { getValues, handleSubmit } = useFormContext()
  const { save } = useSaveContext()

  return (
    <Toolbar {...props}>
      {isProduction ? (
        <OpenModalButton
          button={
            <Button disabled={loading} variant="contained">
              <Save />
            </Button>
          }
          label="Save"
          {...props}
        >
          {(openModalConsumerProps) => (
            <EventCreateConfirmationModal
              {...openModalConsumerProps}
              handleSubmit={(e: any) =>
                handleSubmit(() => save?.(getValues()))(e)
              }
            />
          )}
        </OpenModalButton>
      ) : (
        <SaveButton />
      )}
    </Toolbar>
  )
}

export default EventCreateCustomToolbar
